/* @flow */
export type ColorSetName = "nexia" | "pivot";

export type ColorSet = {
  colorSetName: ColorSetName,
  PRIMARY: string,
  PRIMARY_GRADIENT_DARK: string,
  PRIMARY_GRADIENT_LIGHT: string,
  PRIMARY_TEXT: string,
  SECONDARY: string,
  RED: string,
  LABEL: string,
  IMPORTANT: string,
  WARNING: string,
  COOL: string,
  NEW_COOL: string,
  HEAT: string,
  COOL_GRADIENT_TOP: string,
  COOL_GRADIENT_BOTTOM: string,
  HEAT_GRADIENT_TOP: string,
  HEAT_GRADIENT_BOTTOM: string,
  HEADER_BACKGROUND: string,
  DETAILS_HEADER_BACKGROUND: string,
  FOOTER_BACKGROUND: string,
  FOOTER_TEXT: string,
  SUCCESS: string,
  ACCEPT: string,
  REJECT: string,
  TEXT: string,
  TITLE: string,
  TEXT_SECONDARY: string,
  TEXT_DISABLED: string,
  DIVIDER: string,
  OVERLAY_BACKGROUND: string,
  ANCHOR: string,
};

const ColorSets: {|
  nexia: ColorSet,
  pivot: ColorSet,
|} = {
  nexia: {
    colorSetName: "nexia",
    PRIMARY: "#1685C4",
    PRIMARY_GRADIENT_DARK: "#106db1",
    PRIMARY_GRADIENT_LIGHT: "#1da2da",
    PRIMARY_TEXT: "#ffffff",
    SECONDARY: "#1f729d",
    RED: "#E2231A",
    LABEL: "#5b5b5b",
    IMPORTANT: "#1685C4",
    WARNING: "#fbcd36",
    COOL: "#188FCB",
    NEW_COOL: "#3e83bf",
    HEAT: "#E2231A",
    COOL_GRADIENT_TOP: "#005eb2",
    COOL_GRADIENT_BOTTOM: "#a6d2d3",
    HEAT_GRADIENT_TOP: "#d00000",
    HEAT_GRADIENT_BOTTOM: "#ffb55c",
    HEADER_BACKGROUND: "#f7f5f3",
    DETAILS_HEADER_BACKGROUND: "",
    FOOTER_BACKGROUND: "#1685C4",
    FOOTER_TEXT: "#ffffff",
    SUCCESS: "#08a818",
    ACCEPT: "#3db14b",
    REJECT: "#E2231A",
    TEXT: "#676767",
    TITLE: "#4c4c4c",
    TEXT_SECONDARY: "#808080",
    TEXT_DISABLED: "#e5e5e5",
    DIVIDER: "#efefef",
    OVERLAY_BACKGROUND: "rgba(0,0,0,0.6)",
    ANCHOR: "blue",
  },
  pivot: {
    colorSetName: "pivot",
    PRIMARY: "#526c7f",
    PRIMARY_GRADIENT_DARK: "#3e515f",
    PRIMARY_GRADIENT_LIGHT: "#758999",
    PRIMARY_TEXT: "#ffffff",
    SECONDARY: "#d7d7da",
    RED: "#E2231A",
    LABEL: "#5b5b5b",
    IMPORTANT: "#526c7f",
    WARNING: "#fbcd36",
    COOL: "#188FCB",
    NEW_COOL: "#3e83bf",
    HEAT: "#E2231A",
    COOL_GRADIENT_TOP: "#005eb2",
    COOL_GRADIENT_BOTTOM: "#a6d2d3",
    HEAT_GRADIENT_TOP: "#d00000",
    HEAT_GRADIENT_BOTTOM: "#ffb55c",
    HEADER_BACKGROUND: "#e2f3ff",
    DETAILS_HEADER_BACKGROUND: "#e2f3ff",
    FOOTER_BACKGROUND: "#e4f2d2",
    FOOTER_TEXT: "#526c7f",
    SUCCESS: "#08a818",
    ACCEPT: "#3db14b",
    REJECT: "#E2231A",
    TEXT: "#919ba3",
    TITLE: "#526c7f",
    TEXT_SECONDARY: "#808080",
    TEXT_DISABLED: "#e5e5e5",
    DIVIDER: "#efefef",
    OVERLAY_BACKGROUND: "rgba(0,0,0,0.6)",
    ANCHOR: "#00326c",
  },
};

export default ColorSets;



// WEBPACK FOOTER //
// ../nx-components/src/ColorsProvider/ColorSets.js